import React, { useContext  } from 'react';
import Headings from './sub_components/Headings'
import Input, { LabelField } from './sub_components/inputs';
import { useState , useEffect , useRef} from 'react';
import Container from './atoms/Container';
import { ShowMoreIcon , ShowLessIcon, SortIcon } from './svg/icons/icon';
import Table from './sub_components/Table'
import Contextapi from '../context-api/createContext';
import axios from 'axios'
import { baseUrl } from '../utils.jsx/baseUrl'
import Pagination  from './sub_components/Pagination';
import { RadiusInput , SearchSelect  } from './sub_components/inputs';
import { GreyDropDownIcon } from './svg/icons/icon';
import { Filter , Filter1 } from './sub_components/inputs';
import CustomSlider from './sub_components/slider';
import RadioButton from './sub_components/radioButtons';
import { definitions } from './sub_components/Definitions';
import { RadiusSelect } from './sub_components/inputs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Link} from "react-router-dom"
function SpinnerLoader() {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-white/70 z-50">
      <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
// export default LoardBoard;
const options = [{label : "a" , value : "a" },
  {label : "b" , value:  "b" },
  {label : "c" , value : "c" },
]

const option2 = [
  {label  : 100 , value : 100},
  {label : 200 , value : 200},
   {label : 300 , value : 300}
]




const headers = [
  'Origin',
  'Destination',
  'Equipment',
  'Weight (klbs)',
  'Price ($)',
  'Company',
  'Pickup Date',
  'Age',
  'Distance (mi.)',
] 
 


function LoadBoard1() {
  // const { setIsnavabr } = useContext(Contextapi);
  const [showMore , setShowMore] = useState(false);
  const [loads , setLoads] = useState([]);
  const token = sessionStorage.getItem('token')
  const [page , setPage] = useState(1);
  const [size , setSize]  = useState(10);
  const [weightSlider , setWeightSlider] = useState(0);
  const [priceSlider , setPriceSlider] = useState(0);
    const [selectedItem , setSelectedItem] = useState("");
  const [formData , setFormData ] = useState({
    pickup_from : "",
    pickup_radius : 150,
    dropoff_at : "",
    dropoff_radius : 150,
    date : "",
    trailer_type : "",
    weight : weightSlider,
    broker : "",
    price : priceSlider,
  })
  const [isSearch , setIsSearch] = useState(false);
  const [searchData , setSearchData] = useState([]);
  const [selectedRadioValue , setSelectedRadioValue] = useState({value : "" , sort: ""})
  const [openDropDown , setOpenDropDown] = useState(null);
  const [brokerList ,setBrokerList] = useState([]);
  const [latLng , setLatLng] = useState();
  const [hasDestination , setHasDestination] = useState(false);
  const [loading , setLoading] = useState(true)

  const user_type = sessionStorage.getItem("user_type")
  const userId = sessionStorage.getItem("comId")
  const toggleDropDown = (dropDownName) =>{
    setOpenDropDown((prev) => prev === dropDownName ? null : dropDownName)
  }
 

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "price") {
      setPriceSlider(value);
    }
    if( name == "broker"){
      setSelectedItem(value)
    }
    if (name === "weight") {
      setWeightSlider(value);
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  
  const isDropdownOpen = (dropDownName) => openDropDown === dropDownName;

  const handleChange = async ( value , sort) =>{
    setSelectedRadioValue({value , sort});
    toggleDropDown("filters")
  }

  async function handleSubmit(e){
    e.preventDefault();
    if(!formData.pickup_from){
      toast.warn('Origin is required', {
        autoClose: 2000,
      });
      return;
    }
  
    else  if(!formData.date){
      toast.warn('Date is required', {
        autoClose: 2000,
      });
      return;
    }  
  
    if(formData.dropoff_at !== ""){
      setHasDestination(true)
    }else{
      setHasDestination(false)
    }

    setIsSearch(true);
    setPage(1);
    // toggleDropDown("filters");
    // toggleDropDown("price");
    // toggleDropDown("weight")
    const params = {
      page : 1,
      size : 10,
      hasStoredSearch : false,
      sortField : selectedRadioValue?.value,
      sortOrder : selectedRadioValue?.sort
    }
    const response = await axios.post(`${baseUrl.url}/loads/search` , {...formData , userId , user_type} ,{
      params,
      headers : {
        Authorization : `Bearer ${token}`
      }
    } )
    setSearchData(response.data)
    if(response.data.msg){
      toast.warn(response.data.msg, {
        autoClose: 2000,
      });
    }
  }

  
  const renderTableData = () => {
    if (isSearch) {
      return searchData;
    }
    return loads;
  };


async function getLoads(){
  try {
    const params = {
      page: page, 
      size: size, 
    };
    const url = `${baseUrl.url}/loads/get`;

    const response = await axios.get(url, {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

    const data = response.data;
 
     setLoads(data);

  } catch (error) {
    console.error('Error fetching data:', error);
  }
  finally{
    setLoading(false)
  }
}

async function searchLoads(){
 try{
 if(formData.dropoff_at != ""){
   setHasDestination(true)
 }else{
  setHasDestination(false)
 }
const params = {
  page : page,
  size : size,
  hasStoredSearch : true,
  sortField : selectedRadioValue?.value,
  sortOrder : selectedRadioValue?.sort
}
const response = await axios.post(`${baseUrl.url}/loads/search` , {...formData , userId , user_type} ,{
  params,
  headers : {
    Authorization : `Bearer ${token}`
  }
} )
setSearchData(response.data)
if(response.data.msg){
  toast.warn(response.data.msg, {
    autoClose: 2000,
  });
}
 }
catch(err){
console.log(err)
}
}

useEffect(() => {
  if(!isSearch){
    getLoads();
    // setIsnavabr(true)
  }else{
    searchLoads();
    // setIsnavabr(true)
  }
}, [page, size ]);



const handleKeyDown = (e) =>{
  if(e.key === "Enter"){
    e.preventDefault();
  }
 
}


const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      console.log("Google Maps API is already loaded.");
      resolve();
      return;
    }

    if (document.querySelector(`script[src="${url}"]`)) {
      console.log("Google Maps script is already being loaded.");
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log("Google Maps API script loaded.");
      resolve();
    };

    script.onerror = () => {
      reject(new Error("Google Maps API script failed to load."));
    };

    document.head.appendChild(script);
  });
};


  const [pickupQuery, setPickupQuery] = useState("");
  const [dropoffQuery, setDropoffQuery] = useState("");
  const pickupRef = useRef(null);
  const dropoffRef = useRef(null);


  const handleScriptLoad = (fieldName, updateQuery, ref) => {
    if (!window.google || !window.google.maps) return;

    const bounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(41.644335, -87.940267),
      new window.google.maps.LatLng(42.023131, -87.523661)
    );

    const autocompleteInstance = new window.google.maps.places.Autocomplete(ref.current, {
      bounds,
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry", "name"],
      strictBounds: false,
    });

    autocompleteInstance.addListener("place_changed", () => {
      handlePlaceSelect(fieldName, updateQuery, autocompleteInstance);
    });
    return autocompleteInstance
  };

  const handlePlaceSelect = async (fieldName, updateQuery, autocompleteInstance) => {
    const addressObject = await autocompleteInstance.getPlace();

    if (!addressObject || !addressObject.address_components) {
      console.error("Invalid address object for", fieldName);
      return;
    }

    const query = addressObject?.formatted_address;
    updateQuery(query);


    let state = "";
    let city = "";

    addressObject.address_components.forEach((component) => {
      if (component.types.includes("administrative_area_level_1")) {
        state = component.short_name;
      }
      if (component.types.includes("locality")) {
        city = component.long_name;
      }
    });


  if (!city) {
    toast.warn(`Please enter a valid ${fieldName === "pickup_from" ? "origin" : "destination"} city`, {
      autoClose: 2000,
    });1
    return;
  } 

    const latLng = [
      addressObject?.geometry?.location.lat(),
      addressObject?.geometry?.location.lng(),
    ];

    setLatLng(latLng)
    setFormData((prev) =>({
      ...prev,
      [fieldName] : `${city}, ${state}`,
      [`${fieldName}_latLng`] : latLng
    }))
    
  };


  useEffect(() => {
  loadScript(
    `https://maps.googleapis.com/maps/api/js?key=AIzaSyBkOfRs10Kr8r83VYCwkQld9XzM--mJG7U&libraries=places`
  ).then(() => {
    setTimeout(() => {
      if (window.google && window.google.maps && window.google.maps.places) {
        handleScriptLoad("pickup_from", setPickupQuery, pickupRef);
        handleScriptLoad("dropoff_at", setDropoffQuery, dropoffRef);
      } else {                  
        console.error("Google Maps API failed to load.");
      }
    }, 1000); // Wait 1 second before initializing Autocomplete
  }).catch((error) => {
    console.error("Google Maps script loading failed:", error);
  });
}, []);



const inputValue = (e) =>{
   const {name , value }  = e.target;
   setFormData((prev) => ({
    ...prev,
    [name] : value,
   }))
}




const fetchBrokers = async() =>{
  try{
    const res = await axios.get(`${baseUrl.url}/loads/brokers`,
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    setBrokerList(res.data)
  }catch(err) {
    console.log(err)
  }
}

useEffect(() =>{
   fetchBrokers();
},[])

useEffect(() => {
  if (isSearch) {
    setPage(1); 
  }
}, [isSearch]);



 return (
loading ? <SpinnerLoader /> : <>
  <div  className  = "overflow-y-auto ">
  <Container className="h-auto ">
    <div className="grid rounded-md">
      <div className = "flex flex-cols gap-4 ">
    <Headings heading="Load Board" title="Single Point offers an exclusive members-only load board" />
    <Link to = "/loadboard/singlepointLoads"><button className=" p-3 bg-[#258CFB] text-white rounded-lg text-md justify-center items-center whitespace-nowrap">Single Point Loads</button></Link>

    </div>
    {/* <span className = "text-gray-500">Want to explore Single Point Loads <Link className="text-blue-500" to = "/loadboards/singlepointLoads">Click here</Link></span> */}
<form onSubmit={handleSubmit}>
  <div className="w-full mt-10  font-sfPro font-normal text-base">
    <div className="flex gap-4 items-center justify-start">
        <div className = "flex flex-cols gap-1 min-w-[230px] ">
    
<LabelField
  label="Origin"
  type="text"
  name="pickup_from"
  fieldSize={`w-xl`}
  placeholder="Type origin"
  ref={pickupRef}
  onKeyDown = {handleKeyDown}
  required
  // onChange={(e) => setPickupQuery(e.target.value)}
  onChange={(e) => {
    setPickupQuery(e.target.value);
    setFormData((prev) => ({ ...prev, pickup_from: ""  , pickup_from_latLng : "" }));
  }}
  value={pickupQuery || formData?.pickup_from || ""}
  />

<div className="flex flex-col">
<label className="text-sm mb-[8px] opacity-0">Radius</label>
        <RadiusSelect
          name="pickup_radius"
          required
          value={formData.pickup_radius}
         options={[
            {label  : "100 mi." , value : 100},
            {label : "150 mi." , value : 150},
          {label : "200 mi.", value : 200},
           {label : "300 mi." , value : 300}
          ]}
          onChange={inputValue}
        />
        </div>
      </div>
      
      
      
      <div className="flex flex-cols gap-1 min-w-[230px]">
        <LabelField
         label = 'Destination'
          type="text"
          name="dropoff_at"
          fieldSize={`w-xl`}
          placeholder = "Type destination"    
          ref  = {dropoffRef}
          onKeyDown = {handleKeyDown}
          onChange={(e) => {
            setDropoffQuery(e.target.value);
            setFormData((prev) => ({ ...prev, dropoff_at: "" , dropoff_at_latLng : "" }));
          }}
        value={dropoffQuery || formData?.dropoff_at  || ""}
        />
   <div className="flex flex-col">
   <label className="text-sm mb-[8px] opacity-0">Radius</label>
       <RadiusSelect
          // label="Choose Radius (mi.)"
          // placeholder="Select radius"
          name="dropoff_radius"
          // required
          disabled = {formData.dropoff_at ? false : true}
          value={formData.dropoff_radius}
         options={[
            {label  : "100 mi.", value : 100},
            {label : "150 mi.", value : 150},
          {label : "200 mi.", value : 200},
           {label : "300 mi.", value : 300}
          ]}
          onChange={inputValue}
        />
        </div>
      </div>


      
      {/* Date */}
      <div className="flex-1 min-w-[215px]">
        <Input
          label="Date"
          required
        // placeholder="Enter pick up date"
          type="date"
          name="date"
          value={formData.date}
          onChange={inputValue}
        />
      </div>

     
      {/* Choose Trailer Type */}
      <div className="flex-1 min-w-[215px]">
        <Input
          label="Equipment Type"
          placeholder="No selected Option"
          type="select"
          name="trailer_type"
          value={formData?.trailer_type}
          options={definitions}
          onChange={inputValue}
        />
      </div>
      
      {/* Search Button */}
      <div className="flex gap-2 mt-6  sm:w-auto">
        <button
          className="px-6 py-1 bg-[#258CFB] text-white rounded-lg text-md justify-center items-center whitespace-nowrap"
          type="submit"
        >
          Search
        </button>
      {/* </div> */}
     
      
      {/* Down Arrow Button */}
      {/* <div className="flex-1 mt-6 sm:w-auto"> */}
        <button
          className=" p-3 bg-[#258CFB] text-white rounded-lg text-md justify-center items-center whitespace-nowrap"
          type="button"
          onClick = {() => setShowMore(!showMore)}
        >
         {showMore ? <ShowLessIcon /> :   <ShowMoreIcon /> }
        </button>
       {/* </div> */}

       {/* <div className="flex-1 mt-6 sm:w-auto"> */}
      <button className="px-4 py-1 text-white  bg-[#000] rounded-lg text-md justify-center items-center whitespace-nowrap" type="button" 
onClick={() =>
  {  
    const hasFilters =
    formData.pickup_from ||
    formData.dropoff_at ||
    formData.date ||
    formData.trailer_type ||
    formData.weight > 0 ||
    formData.broker ||
    formData.price > 0;
    
    if(hasFilters){
    setFormData({
          pickup_from : "",
          pickup_radius : 150,
          dropoff_at : "",
          date : "",
          trailer_type : "",
          weight : 0,
          broker : "",
          price : 0
        });
        setWeightSlider(0);
        setPriceSlider(0);
        setSelectedItem("");
        setIsSearch(false)
        setPage(1);
        getLoads();
        }
      }}>Reset</button> 
        </div>

    </div>
  </div>
</form>

{showMore && 
<div className = "flex justify-between mt-4">
  <div className = "flex gap-2">
  <div className = "relative flex flex-row bg-[#F1F5F8] border inline rounded-lg  px-2 text-[#737373] focus:outline-none"
  onClick = {() => {
    toggleDropDown("filters")
    }}>
<span className= "flex items-center pr-1"><span className = "pr-1"><SortIcon /></span><span>Sort by: {selectedRadioValue.value == "loadsize.weight" ? 
"Weight" : selectedRadioValue.value == "rate" ? 
"Price" : selectedRadioValue.value == "pickup_date" ? 
"Pickup Date" : capitalizeFirstLetter(selectedRadioValue.value) || "Recommended"}</span></span>
 </div>

      {
       isDropdownOpen('filters') &&
    <div className = "absolute  bg-white p-4 rounded-xl top-[29%] w-[11%] shadow shadow-gray-400" >

  <RadioButton 
   label = "Weight"
   value = "loadsize.weight" 
   checked = {selectedRadioValue.value === "loadsize.weight" && selectedRadioValue.sort === "asc"}
   onChange = {handleChange} 
   sort = "asc" />
  <RadioButton 
   label = "Weight" 
   value = "loadsize.weight"  
   checked = {selectedRadioValue.value === "loadsize.weight" && selectedRadioValue.sort === "desc"}
   onChange = {handleChange}
   sort = "desc" />
  <RadioButton  
  label = "Price"
   value = "rate" 
   checked = {selectedRadioValue.value === "rate" && selectedRadioValue.sort === "asc"}
   onChange = {handleChange}
   sort = "asc" />
  <RadioButton 
   label = "Price" 
   value = "rate" 
   checked = {selectedRadioValue.value === "rate" && selectedRadioValue.sort === "desc"} 
   onChange = {handleChange}
   sort = "desc" />
  <RadioButton  
  label = "Distance" 
  value = "distance" 
  checked = {selectedRadioValue.value === "distance" && selectedRadioValue.sort === "asc"}
  onChange = {handleChange}
  sort = "asc" />
 <RadioButton  
 label = "Distance" 
 value = "distance" 
 checked = {selectedRadioValue.value === "distance" && selectedRadioValue.sort === "desc"} 
 onChange = {handleChange} 
 sort = "desc" />
 <RadioButton  
 label = "Pickup Date" 
 value = "pickup_date" 
 checked = {selectedRadioValue.value === "pickup_date" && selectedRadioValue.sort === "asc"}
 onChange = {handleChange} 
 sort = "asc" />
 <RadioButton 
  label = "Pickup Date" 
  value = "pickup_date"  
  onChange = {handleChange} 
  checked = {selectedRadioValue.value === "pickup_date" && selectedRadioValue.sort === "desc"}
  sort = "desc" />

 </div>

  }


   <Filter1
   label = "Weight"
    name="weight"
   onClick = {() => {
    toggleDropDown("weight")
   }}
   value={weightSlider}
    units = "lbs"
    onChange={handleInputChange}
   />


{
isDropdownOpen('weight') &&
<div className = "relative ">
  
   <CustomSlider 
   value = {weightSlider}
   onChange = {(newValue) => {
    setWeightSlider(newValue)
    inputValue({target : {name : "weight" , value : newValue}})
  }}
   name = "weight"
   mini = {0}
   maxi = {10000}
   units = "lbs"
/>
   </div>
}
      
    <Filter1 label = "Price" name = "price"
    onClick = {() => {
      toggleDropDown("price")
    }}
    value={priceSlider}
    units = "$"
    onChange={handleInputChange}
    /> 

    {
    isDropdownOpen('price') &&
<div className = "relative ">
  
   <CustomSlider 
   value = {priceSlider}
   onChange = {(newValue) => {
    setPriceSlider(newValue);
    inputValue({target : {name  : "price", value : newValue}})
   }}
   name = "price"
   mini = {0}
   maxi = {2000}
   units = "$"   
   />
   </div>
}
   
                                             
<Filter1 label = "Broker" name = "broker"
    onClick = {() => {
      toggleDropDown("broker")
    }}
    value={selectedItem || ""}
    units = ""
    onChange={handleInputChange}
    /> 
{
isDropdownOpen("broker") && 
<div className = "relative ">
 <SearchSelect 
label = "broker"
 type = "select"
 options = {brokerList}
onClick = {(item) => {

  if (item === selectedItem) {
    setSelectedItem("");
    inputValue({ target: { name: "broker", value: "" } });
  } else {
    setSelectedItem(item);
    inputValue({ target: { name: "broker", value: item } });
  }
  toggleDropDown("broker")
}}
/>
</div>

}
</div>
<div className = "flex flex-row items-center gap-2 justify-end">
<span className = "text-[12px] text-[#737373]  pr-2">{isSearch ? searchData?.totalDocs  : loads?.totalDocs} results found</span>

</div>
</div>
}

  <Table headers={headers} data={renderTableData()}  isSearch = {isSearch} hasDestination = {hasDestination} page = {page}/>


{searchData?.docs?.length != 0 && <Pagination  page = {page} setPage = {setPage}  info = {isSearch? searchData : loads}  />}
  </div>
 
  </Container>
  <ToastContainer />
  </div>
  </>
 )
}

export default LoadBoard1


